import { Component } from '@angular/core';
import { RedirectService } from '../../shared/services/redirect.service';
import { ENV } from '../../environment';

@Component({
  selector: 'yi-link-expired',
  template: require('./expired.component.html'),
  styles: [require('./expired.component.scss')],
})

export class ExpiredComponent {

  constructor(private redirectService: RedirectService) {
  }

  openLink() {
    this.redirectService.redirectTo(ENV.YotpoNewB2bEndpoint + '#/login');
  }
}
